import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step2 from "../assets/image/foxit/step2.png";
import step3 from "../assets/image/foxit/step3.png";
import step4 from "../assets/image/foxit/step4.png";
import step5 from "../assets/image/foxit/step5.png";
import step6 from "../assets/image/foxit/step6.png";
import step7 from "../assets/image/foxit/step7.png";
import step8 from "../assets/image/foxit/step8.png";
import step9 from "../assets/image/foxit/step9.png";
import step10 from "../assets/image/foxit/step10.png";
import step11 from "../assets/image/foxit/step11.png";


const Foxit = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-19";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return [
            t("sidebar.cases.foxit"),
            "",

            t("foxit.step1"),
            `- ${t("foxit.step1a")}`,
            `- ${t("foxit.step1b")}`,
            "",

            t("foxit.step2"),
            t("foxit.step3"),
            t("foxit.step4"),
            t("foxit.step5"),
            t("foxit.step6"),
            "",

            t("foxit.step7"),
            `- ${t("foxit.step7a")}`,
            `- ${t("foxit.step7b")}`,
            `- ${t("foxit.step7c")}`,
            `- ${t("foxit.step7d")}`,
            `- ${t("foxit.step7e")}`,
            `- ${t("foxit.step7f")}`,
            "",

            t("foxit.step8"),
            `- ${t("foxit.step8a")}`,
            "",

            t("foxit.step9"),
            t("foxit.step10"),
            t("foxit.step11"),
        ].join("\n");
    };
    
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={caseIcon} alt="case" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.cases.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.cases.foxit")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("foxit.step1a")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("foxit.step1b")}
                            </li>
                        </ul>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step2

                        }}>
                            <img
                                src={step2}
                                alt="step2"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step3

                        }}>
                            <img
                                src={step3}
                                alt="step3"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step4

                        }}>
                            <img
                                src={step4}
                                alt="step4"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step5

                        }}>
                            <img
                                src={step5}
                                alt="step5"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step6"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step6

                        }}>
                            <img
                                src={step6}
                                alt="step6"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step7"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="list-none text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7e"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step7f"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step7

                        }}>
                            <img
                                src={step7}
                                alt="step7"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step8"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="foxit.step8a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step8

                        }}>
                            <img
                                src={step8}
                                alt="step8"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step9"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step9

                        }}>
                            <img
                                src={step9}
                                alt="step9"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step10"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step10

                        }}>
                            <img
                                src={step10}
                                alt="step10"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="foxit.step11"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11

                        }}>
                            <img
                                src={step11}
                                alt="step11"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.cases.powerPoint")}
                            to="/cases/powerpoint"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.acrobatReader")}
                            to="/cases/acrobat-reader"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default Foxit
